import React from 'react';
import Tippy from '@tippyjs/react';
import { format } from 'date-fns';

import styles from './StatBadge.module.scss';

// Shared hover copy for delta badges — the pills don't otherwise say what
// period they compare against.
export const comparisonLabel = (comparison) =>
	`Compared with the previous period (${format(comparison.startDate, 'd MMM')} – ${format(comparison.endDate, 'd MMM')})`;

/**
 * Compact +/- delta badge for the Overview cards. Matches Lovable's StatBadge:
 * green-soft pill for "good" direction, red-tint pill for "bad".
 *
 * @param {object} props
 * @param {number} props.value — the percentage delta (e.g. 12.4 or -4.2)
 * @param {boolean} [props.positive] — whether positive value is "good" (true) or "bad" (false). For metrics like "cost", set false to invert the colour.
 * @param {string} [props.tooltip] — hover explanation, e.g. what period the delta compares against
 */
export const StatBadge = ({ value, positive = true, tooltip }) => {
	const isUp = positive ? value >= 0 : value < 0;
	const badge = (
		<span className={`${styles.badge} ${isUp ? styles.up : styles.down}`}>
			{value > 0 ? '+' : ''}
			{value}%
		</span>
	);
	if (!tooltip) return badge;
	return (
		<Tippy content={tooltip} delay={[80, 0]}>
			{badge}
		</Tippy>
	);
};
